import { Modal, Text } from '@profitowi/component-library';
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { ModalActions } from 'components';
import ErrorMessages from 'components/ErrorMessages/ErrorMessages';
import { updateAgentBlockade } from 'services/agent';
import { AgentDetailsBlockade } from 'types/agent';

type Props = {
  closeModal: () => void;
  refetch: () => void;
  visible: boolean;
  blockadeToDelete: AgentDetailsBlockade | null;
  setBlockadeToDelete: (blockadeToDelete: AgentDetailsBlockade | null) => void;
};

const DisableBlockadeModal = ({
  visible,
  refetch,
  closeModal,
  blockadeToDelete,
  setBlockadeToDelete,
}: Props) => {
  const { isError, error, isLoading, mutate } = useMutation<
    AxiosResponse,
    AxiosError,
    { payload: AgentDetailsBlockade }
  >(({ payload }) => updateAgentBlockade(payload), {
    onSuccess: () => {
      closeModal();
      refetch();
    },
  });

  return (
    <Modal title="Dezaktywuj blokadę" visible={visible}>
      <Text>Czy na pewno chcesz dezaktywować blokadę? Ta operacja jest nieodwracalna.</Text>
      <ModalActions
        onCancel={() => {
          closeModal();
          setBlockadeToDelete(null);
        }}
        onConfirm={() => {
          if (blockadeToDelete) {
            mutate({ payload: { ...blockadeToDelete, state: false } });
          }
        }}
        isLoading={isLoading}
      />
      {isError && <ErrorMessages error={error} />}
    </Modal>
  );
};

export default DisableBlockadeModal;
